import template from './nest.html';
import controller from './nest.controller';

let nestComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default nestComponent;



// WEBPACK FOOTER //
// ./client/app/components/nest/nest.component.js